module.exports = __webpack_public_path__ + "static/img/group-tip.f960f61e.png";